import { Flex, Text } from '@scale/scaleui-radix';
import { Locale } from '@scale/genai-compass-shared/cards/calendar_data_generator';

interface LocaleSelectorProps {
  value: Locale[];
  onChange: (locales: Locale[]) => void;
}

export default function LocaleSelector({ value, onChange }: LocaleSelectorProps) {
  const allLocales = Object.values(Locale);

  const handleChange = (selectedValue: string) => {
    const locale = selectedValue as Locale;
    if (value.includes(locale)) {
      // Remove locale
      onChange(value.filter(l => l !== locale));
    } else {
      // Add locale
      onChange([...value, locale]);
    }
  };

  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="medium">
        Locales (Cmd/Ctrl to select multiple)
      </Text>
      <Flex direction="column" gap="2" style={{ maxHeight: '200px', overflow: 'auto' }}>
        {allLocales.map(locale => (
          <label key={locale} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={value.includes(locale)}
              onChange={() => handleChange(locale)}
            />
            <Text size="2">{locale}</Text>
          </label>
        ))}
      </Flex>
      <Text size="1" color="gray">
        Selected: {value.length} locale{value.length !== 1 ? 's' : ''}
      </Text>
    </Flex>
  );
}
